import { accessHistoryTypes as actionTypes } from '@actions';
import { commonState, commonReducer, pagination } from '@dotone/react-ui-core/helpers';

const collectionState = {
  ...commonState.default({ collection: true }),
  pagination,
};

export const accessHistoryList = (state = collectionState, action) =>
  commonReducer(actionTypes.LIST, state, action);

export const accessHistoryDistrust = (state = commonState.default(), action) =>
  commonReducer(actionTypes.DISTRUST, state, action);
